import { BaseDialog, type BaseDialogProps } from '@/components/Dialog/BaseDialog';

/**
 * ModalDialog - A dialog that requires explicit user interaction to close
 *
 * @description
 * ModalDialog is a convenience wrapper around BaseDialog that automatically
 * disables the ESC key. This makes it ideal for critical dialogs where you want
 * to ensure users make an explicit choice rather than accidentally dismissing the dialog.
 *
 * Unlike BaseDialog, users cannot close this dialog by pressing ESC - they must
 * click a button or the close icon (if provided).
 *
 * Use BaseDialog instead when:
 * - The dialog contains informational content
 * - Users should be able to quickly dismiss it
 * - The interaction is non-critical
 *
 * @param props - All BaseDialogProps except disableEscapeKeyDown (automatically set to true)
 * @returns A BaseDialog with ESC key disabled
 */
export const ModalDialog = (props: BaseDialogProps) => <BaseDialog {...props} disableEscapeKeyDown={true} />;
